import { ErrorMessage, Form, Formik } from "formik";
import { useContext, useEffect, useState } from "react";
import SidebarField from "../SidebarField";
import Button from "../Button";
import { IoAddCircleOutline } from "react-icons/io5";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { FormField } from "../FormField";
import TextInput from "../TextInput";
import ToggleField from "../ToggleField";
import Lable from "../Lable";
import Tooltip from "../Tooltip/Tooltip";
import { Divider } from "primereact/divider";
import ReactQuill from "react-quill";
import TaxData from "./TaxData";
import { ImagesData } from "./ImageData";

function VariantData({open,close,data}) {
  const product_details_info = {
    product_size: "Enter a size of product eg. 120GB, S/M/L/XL/XXL, 1 liter!",
    mrp_price: "Enter a MRP Price of product!",
    sales_price: "Enter a Sales Price of product!",
    stock: "Enter a number of stock!",
    product_width: "Enter a Width in of product in centimetre!",
    product_height: "Enter a Height of product in centimetre !",
    product_depth: "Enter a Depth of product in centimetre!",
    product_weight: "Enter a Weight of product in gram!",
  };
// console.log('data',data);

  // const data= {
  //     "_id": "672dd249df260cfe2e3818d6",
  //     "product": "672dc3e5df260cfe2e3817c5",
  //     "primary_image": "http://res.cloudinary.com/doyb9ojic/image/upload/v1731056200/rs7ihavtxmwsc7jwn618.jpg",
  //     "secondary_image": [
  //         "http://res.cloudinary.com/doyb9ojic/image/upload/v1731056201/mfdtpgekyjcjzkdybomk.jpg",
  //         "http://res.cloudinary.com/doyb9ojic/image/upload/v1731056201/uoopvrkvxtttfa1jfotp.jpg",
  //         "http://res.cloudinary.com/doyb9ojic/image/upload/v1731056202/gqsd77cnmqbhzkkfkyeq.jpg",
  //         "http://res.cloudinary.com/doyb9ojic/image/upload/v1731056272/dnzqegntzfmjy34l6hbf.jpg"
  //     ],
  //     "name": "Apple iPhone 13 (128GB) - Green",
  //     "serial_number": "null",
  //     "is_visible": false,
  //     "product_color": [
  //         "#c40808"
  //     ],
  //     "product_details": [
  //         {
  //             "taxData": {
  //                 "referralFee": {
  //                     "percentage": "5",
  //                     "amount": {
  //                         "$numberDecimal": "7843.47"
  //                     }
  //                 },
  //                 "standardTax": [
  //                     {
  //                         "name": "GETFund",
  //                         "rate": {
  //                             "$numberDecimal": "2.5"
  //                         },
  //                         "taxType": "REBASE TAX",
  //                         "taxAmount": {
  //                             "$numberDecimal": "3699.75"
  //                         },
  //                         "_id": "673f0a89e1ed70ba3dfb95e2"
  //                     },
  //                     {
  //                         "name": "NHIL",
  //                         "rate": {
  //                             "$numberDecimal": "2.5"
  //                         },
  //                         "taxType": "REBASE TAX",
  //                         "taxAmount": {
  //                             "$numberDecimal": "3699.75"
  //                         },
  //                         "_id": "673f0a89e1ed70ba3dfb95e3"
  //                     },
  //                     {
  //                         "name": "COVID",
  //                         "rate": {
  //                             "$numberDecimal": "1"
  //                         },
  //                         "taxType": "REBASE TAX",
  //                         "taxAmount": {
  //                             "$numberDecimal": "1479.9"
  //                         },
  //                         "_id": "673f0a89e1ed70ba3dfb95e4"
  //                     }
  //                 ],
  //                 "standardTotalTaxAmount": {
  //                     "$numberDecimal": "8879.40"
  //                 },
  //                 "closingFee": {
  //                     "$numberDecimal": "0.50"
  //                 },
  //                 "additionalFee": {
  //                     "$numberDecimal": "10.00"
  //                 },
  //                 "rebase": {
  //                     "$numberDecimal": "156869.40"
  //                 },
  //                 "taxableAmount": {
  //                     "$numberDecimal": "164723.37"
  //                 },
  //                 "vat": [
  //                     {
  //                         "name": "VAT",
  //                         "rate": {
  //                             "$numberDecimal": "20"
  //                         },
  //                         "taxType": "REBASE TAX",
  //                         "taxAmount": {
  //                             "$numberDecimal": "32944.67"
  //                         },
  //                         "_id": "673f0a89e1ed70ba3dfb95e5"
  //                     }
  //                 ],
  //                 "grandTotal": {
  //                     "$numberDecimal": "197668.04"
  //                 }
  //             },
  //             "product_size": "128GB",
  //             "mrp_price": {
  //                 "$numberDecimal": "154900"
  //             },
  //             "sales_price": {
  //                 "$numberDecimal": "147990"
  //             },
  //             "stock": 4,
  //             "product_width": 13,
  //             "product_height": 7.4,
  //             "product_depth": 0,
  //             "product_weight": 100,
  //             "_id": "672dd249df260cfe2e3818d7"
  //         }
  //     ],
  //     "description": "<p><span style=\"background-color: rgb(255, 255, 255); color: rgb(33, 33, 33);\">iPhone 13. boasts an advanced dual-camera system that allows you to click mesmerising pictures with immaculate clarity. Furthermore, the lightning-fast A15 Bionic chip allows for seamless multitasking, elevating your performance to a new dimension. A big leap in battery life, a durable design, and a bright Super Retina XDR display facilitate boosting your user experience.</span></p>",
  //     "additional_info": "<p><strong>Brand </strong>Apple</p><p><strong>Operating System </strong>iOS 14</p><p><strong>Memory Storage Capacity </strong>128 GB</p><p><strong>Screen Size</strong>6.1 Inches</p><p><strong>Resolution </strong>4K</p>",
  //     "specification": "<ul><li><span style=\"color: var(--__N4QdCheV6mGo,#0f1111);\">5 cm (6.1-inch) Super Retina XDR display</span></li><li><span style=\"color: var(--__N4QdCheV6mGo,#0f1111);\">Cinematic mode adds shallow depth of field and shifts focus automatically in your videos</span></li><li><span style=\"color: var(--__N4QdCheV6mGo,#0f1111);\">Advanced dual-camera system with 12MP Wide and Ultra Wide cameras; Photographic Styles, Smart HDR 4, Night mode, 4K Dolby Vision HDR recording</span></li><li><span style=\"color: var(--__N4QdCheV6mGo,#0f1111);\">12MP TrueDepth front camera with Night mode, 4K Dolby Vision HDR recording</span></li><li><span style=\"color: var(--__N4QdCheV6mGo,#0f1111);\">A15 Bionic chip for lightning-fast performance</span></li></ul>",
  //     "createdAt": "2024-11-08T08:56:41.811Z",
  //     "updatedAt": "2024-11-21T10:25:13.871Z",
  //     "__v": 0
  // }

  const initialProductValues = {
      primary_image: data?.primary_image || null,
      secondary_image: data?.secondary_image || null,
      name: data?.name || null,    
      serial_number: data?.serial_number || null,
      product_color: data?.product_color || "",
      product_details:
        data === "" || data?.product_details?.length === 0
          ? [
              {
                product_size: null,
                mrp_price: null,
                sales_price: null,
                stock: null,
                product_width: null,
                product_height: null,
                product_depth: 0,
                product_weight: null,
              },
            ]
          : data?.product_details,
      additional_info: data?.additional_info || null,
      description: data?.description || null,
      specification: data?.specification || null,
      cancellation_policy: data?.cancellation_policy || null,
      replacement_policy: data?.replacement_policy || null,
      return_policy: data?.return_policy || null,
      is_visible: data?.is_visible || true,
      sequence: data?.sequence || null,
    };

    const handleClose=()=>{
      close()
    }
   
    if (open) { 
      return (
        <>
           {open && (
            <Formik enableReinitialize={true} initialValues={initialProductValues} onSubmit={()=>{}}>
              {({ handleChange, setFieldValue, values }) => (
                <SidebarField
                  // button1={
                  //   step === 0 ? (
                  //     ""
                  //   ) : (
                  //     <Button text="Close" type="button" onClick={close} />
                  //   )
                  // }
                //   button0={
                //     step === 2 && (
                //       <Button
                //         text="Add Variant"
                //         type="button"
                //         onClick={openAddOrEditVariant}
                //       />
                //     )
                //   }
                  // button2={
                  //   <Button
                  //     text={"Next "}
                  //     type="submit"
                  //     onClick={() => handleNext(values)}
                  //   />
                  // }
                  handleClose={() => handleClose()}
                  title={"Variant Details"}
                >
                  
                  <Form className="w-full gap-4 flex flex-col bg-transparent py-5 px-3">
                  <div>
                        <div className="flex items-center justify-center">
                          <label
                            htmlFor="primary_image"
                            className="w-60 h-60 shadow-lg border border-gray-200 rounded-xl flex flex-col items-center justify-center cursor-pointer transition-all duration-200 hover:shadow-xl hover:border-blue-400"
                          >
                            {/* Display Uploaded Image */}
                            {data?._id &&
                            typeof values.primary_image !== "object" ? (
                              <LazyLoadImage
                                src={values.primary_image}
                                alt="Uploaded"
                                loading="lazy"
                                effect="blur"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "contain",
                                }}
                                className="rounded-xl"
                              />
                            ) : ""}
                          </label>
                        </div>
                        <ImagesData imagesData={values.secondary_image} />                         
                        <FormField label="Item Name" tooltip="Enter product name">
                          <div className="flex items-center" id="item_name">
                            <span className="border p-2 pl-3 pr-5 text-sm border-r-none">
                              EN
                            </span>
                            <TextInput                         
                              type="text"                          
                              value={values.name}                        
                              disabled={true}
                            />
                          </div>                   
                        </FormField>                   
                                           
                        <div id="is_color">
                          <ToggleField
                            text="Color?"
                            name="is_color"
                            value={values.product_color}    
                            disabled={true}                    
                          />                     
                        </div>
                        {values.product_color ? (
                          <FormField
                            label="Product color"
                            tooltip="Pick Product Color"
                          >
                            <div
                              className="flex items-center  relative"
                              id="product_color"
                            >
                              <label
                                style={{ background: values.product_color }}
                                htmlFor="product_color"
                                className={`overflow-hidden  border-2 border-gray-950  w-full h-[2rem] inline-block`}
                              >
                                <input
                                  id="product_color"
                                  name="product_color"
                                  type="color"
                                  placeholder="color"
                                  value={values.product_color}
                                  // onChange={handleChange}
                                  required={false}
                                  style={{
                                    width: "100%",
                                    height: "6rem",
                                    marginTop: "-2rem",
                                    border: "none",
                                    outline: "none",
                                    borderRadius: "100%",
                                    background: "transparent",
                                  }}
                                  disabled={true}
                                />
                              </label>
                            </div>
                          </FormField>
                        ) : (
                          ""
                        )}                    
                        <div className="flex items-center justify-between mb-2">
                         
                          <span className="flex">
                            <Lable lable={"Product Details"} />
                            <Tooltip text={"Add more details of Product"} />
                          </span>
                          
                        </div>
    
                        <div id="product_details" className=" w-full">
                          {values.product_details?.map((item, i) => (
                            <>
                              {Object.keys(item).map((label, index) => (
                                <div
                                  id={`${label}_${i}`}
                                  key={`${i}${index}`}
                                  className={`border ${
                                    label === "product_size" ||
                                    label === "mrp_price" ||
                                    label === "sales_price" ||
                                    label === "stock" ||
                                    label === "product_width" ||
                                    label === "product_width" ||
                                    label === "product_height" ||
                                    label === "product_weight" ||
                                    label === "product_depth"
                                      ? "flex"
                                      : "hidden"
                                  }  justify-between mb-1 items-center text-[12px]`}
                                >
                                  <span className="w-[50%] border-r px-2 py-2  gap-2 capitalize  flex justify-between items-center">
                                    <label className="text-[.85rem]">
                                      {label.replace("_", " ")}
                                    </label>{" "}
                                    <Tooltip text={product_details_info[label]} />
                                  </span>
                                  <TextInput
                                    name={`${label}`}
                                    type={
                                      label === "product_size" ? "text" : "number"
                                    }
                                    placeholder={`${label.replace("_", " ")}`}
                                   disabled={true}
                                    value={
                                      label === "mrp_price" ||
                                      label === "sales_price"
                                        ? values.product_details[i][`${label}`]
                                            ?.$numberDecimal
                                          ? values.product_details[i][`${label}`]
                                              ?.$numberDecimal
                                          : values.product_details[i][`${label}`]
                                        : values.product_details[i][`${label}`]
                                    }
                                    required={
                                      label === "product_size" ||
                                      label === "product_depth"
                                        ? false
                                        : true
                                    }
                                    className={`capitalize`}
                                  />
                                </div>
                              ))}
                              <Divider className="border border-gray-300" />
                              <div>
                                <h1>Tax Details</h1>
                                {/* {JSON.stringify(productDetailsWithTax)} */}
                                <TaxData key={i} item={item} />
                              </div>
    
                              {/* <TaxView Taxes={Taxes} deliveryFee={deliveryType} item={item?.sales_price?.$numberDecimal?{sales_price:item?.sales_price?.$numberDecimal}:item}/> */}
                              <Divider className="border border-gray-300" />
                            </>
                          ))}                      
                        </div>                   
    
                        <FormField
                          label="Description"
                          tooltip="write a brief description of item"
                        >
                          <div id="description">
                            <ReactQuill
                              theme="snow"
                              value={values.description}
                              // onChange={(v) => setFieldValue("description", v)}
                              readOnly={true}
                            />                      
                          </div>
                        </FormField>
    
                        <FormField
                          label="Additional Information"
                          tooltip="write a brief additional information of item"
                        >
                          <div id="additional_info">
                            <ReactQuill
                              theme="snow"
                              value={values.additional_info}
                              readOnly={true}
                              // onChange={(v) => setFieldValue("additional_info", v)}
                            />                       
                          </div>
                        </FormField>
    
                        <FormField
                          label="Specifications"
                          tooltip="write a brief Specifications of item"
                        >
                          <div id="specification">
                            <ReactQuill
                              theme="snow"
                              value={values.specification}
                              readOnly={true}
                              // onChange={(v) => setFieldValue("specification", v)}
                            />                     
                          </div>
                        </FormField>
    
                        {/* <FormField
                          label="Cancellation policy"
                          tooltip="write a brief Cancellation policy of item"
                        >
                          <div id="cancellation_policy">
                            <ReactQuill
                              theme="snow"
                              value={values.cancellation_policy}
                              readOnly={true}
                              // onChange={(v) =>
                              //   setFieldValue("cancellation_policy", v)
                              // }
                            />                       
                          </div>
                        </FormField>
                        <FormField
                          label="Replacement policy"
                          tooltip="write a brief replacement policy of item"
                        >
                          <div id="replacement_policy">
                            <ReactQuill
                              theme="snow"
                              value={values.replacement_policy}
                              readOnly={true}
                              // onChange={(v) =>
                              //   setFieldValue("replacement_policy", v)
                              // }
                            />                     
                          </div>
                        </FormField>
    
                        <FormField
                          label="Return policy"
                          tooltip="write a brief return policy of item"
                        >
                          <div id="return_policy">
                            <ReactQuill
                              theme="snow"
                              value={values.return_policy}
                              readOnly={true}
                              // onChange={(v) => setFieldValue("return_policy", v)}
                            />                     
                          </div>
                        </FormField> */}
    
                        <div className="flex justify-between flex-wrap-reverse gap-4">
                          <div id="is_visible">
                            <ToggleField
                              text="Is Item Visible to user?"
                              name="is_visible"
                              value={values.is_visible}
                              disabled={true}
                            />                     
                          </div>
    
                          <FormField
                            label="Sequence Number"
                            tooltip="Enter sequence Number"
                          >
                            <div id="sequence">
                              <TextInput
                                name="sequence"
                                type="number"
                                value={values.sequence}
                                disabled={true}
                                // onChange={handleChange}
                              />
                            </div>                      
                          </FormField>
                        </div>                 
                      </div>  
                     </Form>
                </SidebarField>
              )}
            </Formik>
          )}
        </>
      )
    }
}

export default VariantData